module.exports = __webpack_public_path__ + "img/applepay_2024_10_23.4926e07.svg";